import { render, staticRenderFns } from "./FormMealBlockSettings.vue?vue&type=template&id=660edbf3"
import script from "./FormMealBlockSettings.vue?vue&type=script&lang=js"
export * from "./FormMealBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports